import { Dropdown, DropdownProps } from '@/components/atoms/Dropdown';
import { ReplyButton } from '@/components/molecules/ThreadActionButton/ReplyButton';
import { VoteButton } from '@/components/molecules/VoteButton';
import { formatPostTimeToDisplayValue } from './helpers';

interface CommentHeaderProps {
  user: {
    avatar?: string;
    username: string;
  };
  createdAt: string;
  commentActions: DropdownProps['actions'];
}

interface CommentContentProps {
  content: string;
  upvotes: number;
  downvotes: number;
  onVote: (vote: 'upvote' | 'downvote') => Promise<void>;
  votedFor?: 'upvote' | 'downvote' | null;
  onReply: () => void;
}

export interface CommentProps extends CommentHeaderProps, CommentContentProps {
  id: string;
}

export const CommentHeader = ({
  user,
  createdAt,
  commentActions,
}: CommentHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-m text-center">
        <span className="text-body1Regular text-neutral-900">
          {user.username}
        </span>
        <span className="text-body2Light text-neutral-600">
          {formatPostTimeToDisplayValue(createdAt)}
        </span>
      </div>
      <Dropdown
        aria-label="actions for this comment"
        actions={commentActions}
      />
    </div>
  );
};

export const CommentContent = ({
  content,
  votedFor,
  upvotes,
  downvotes,
  onReply,
  onVote,
}: CommentContentProps) => {
  return (
    <div className="flex flex-col gap-m">
      <p className="text-body2Light text-neutral-800">{content}</p>
      <div className="flex gap-l">
        <VoteButton
          type="upvote"
          voted={votedFor === 'upvote'}
          voteCount={upvotes}
          onClick={() => onVote('upvote')}
        />
        <VoteButton
          type="downvote"
          voted={votedFor === 'downvote'}
          voteCount={downvotes}
          onClick={() => onVote('downvote')}
        />
        <ReplyButton onClick={onReply} />
      </div>
    </div>
  );
};
